/**
 * GET a /api/Clientes/ObtenerClientes. Lista clientes con filtros de búsqueda.
 */
import axiosController from "helpers/axiosController";
const GETClientes = async (loggedUser) => {
  try {
    const { token } = loggedUser;
    const config = {
      method: "GET",
      url: `${process.env.REACT_APP_API_URL}/clientes/get_clientes`,
      headers: {
        Accept: "application/json, text/plain, */*",
        "Accept-Language":
          "es-ES,es;q=0.9,it;q=0.8,en;q=0.7,pt;q=0.6,ar;q=0.5,zh-CN;q=0.4,zh;q=0.3",
        Authorization: `Bearer ${token}`,
      },
    };

    const response = await axiosController.request(config);

    if (response.status === 200) {
      return response.data; // Retornar solo los datos relevantes
    }
  } catch (error) {
    if (error.response) {
      // Error de respuesta del servidor
      return { status: error.response.status, data: error.response.data };
    } else if (error.request) {
      // No se recibió respuesta del servidor
      return { status: 500, message: "No se recibió respuesta del servidor" };
    } else {
      // Otro tipo de error
      return { status: 400, message: "Error al realizar la solicitud" };
    }
  }
};

export default GETClientes;
